import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { z } from "zod";
import { jsonStringSchema } from "@/lib/validators";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.GMAIL;
const controlName = getControlName(controlCode);

export const GmailIntegrationForm = ({ instance }: { instance?: Control }) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`Connect to ${controlName}, and evaluate the efficacy of your email protections.`}
    fields={{
      admin: {
        label: "Administrator Email Address",
        type: "email",
        defaultValue: instance?.username,
        placeholder: "Enter your Administrator Email Address",
        required: true,
        validator: z.string().email(),
      },
      credentials: {
        label: "Credentials JSON",
        type: "file",
        placeholder: "Upload your credentials.json",
        required: true,
        validator: jsonStringSchema,
      },
    }}
    transformParams={({ admin, credentials }) => ({
      api: "",
      user: admin,
      secret: credentials,
    })}
  />
);
